import { type AxiosError, type AxiosRequestConfig } from 'axios';

import { identityInstance } from '@services/base/apiService';

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => identityInstance<T>(config, options);

export type ErrorType<Error> = AxiosError<Error>;
